export const GENERAL = {
  LOADING_KEY: {
    AUTH_LOGIN: 'authLogin',
    CREATE_ACCOUNT: 'authCreateAccount',
    VALIDATE_TOKEN: 'authValidateToken',
    AUTH_SIGN_UP: 'saveAccount',
    SAVE_CLIENT: 'saveClient',
    ADD_UNVERIFIED_COMPANIES_START: 'addUnverifiedCompaniesStart',
    FETCH_CLIENT_HIERARCHY: 'fetchClientHierarchy',
    UPDATE_CLIENT_HIERARCHY: 'updateClientHierarchy',
    UNMARK_BRANCH: 'unmarkBranch',
    FETCH_CLIENT_BRANCHES: 'fetchClientBranches',
    INVITE_COMPANY_AS_BRANCH: 'inviteCompanyAsABranch',
    INVITE_DRAFT_CLIENT: 'inviteDraftClient',
    SAVE_PROJECT: 'saveProject',
    SAVE_CONSENT_FORM_FIELDS_BULK: 'saveConsentFormFieldsBulk',
    UPDATE_CONSENT_FORM_FIELD_BY_ID: 'updateConsentFormFieldById',
    DELETE_CONSENT_FORM_FIELD: 'deleteConsentFormField',
    SEND_APPROVE_CLIENT: 'sendClientForApproval',
    SEND_ONBOARDING_APPROVE_CLIENT: 'sendOnboardingClientForApproval',
    APPROVE_CLIENT: 'approveClient',
    APPROVE_ONBOARDING_CLIENT: 'approveOnboardingClient',
    FETCH_MBE_WBE: 'fetchMwbeType',
    FETCH_TRADES: 'fetchTrades',
    FETCH_CONSENT_FORM_FIELDS: 'fetchConsentFormFields',
    FETCH_REGULAR_EXPRESSIONS: 'fetchRegularExpressions',
    FETCH_CLIENT: 'fetchClient',
    FETCH_ONBOARDING_CLIENT: 'fetchOnboardingClient',
    FETCH_CLIENTS_ALLOWED_TO_CREATE_UNVERIFIED_CLIENTS: 'fetchUnverifiedClientCompanies',
    FETCH_SELF_COMPANY: 'fetchSelfCompany',
    FETCH_MERGE_COMPANY_SUMMARY: 'fetchMergeCompanySummary',
    FETCH_MERGE_COMPANY_PROJECT_SUMMARY: 'fetchMergeCompanyProjectSummary',
    FETCH_MERGE_COMPANY_USERS: 'fetchMergeCompanyUser',
    SAVE_MERGE_COMPANY: 'saveMergeCompany',
    FETCH_CLIENT_LIST: 'fetchClientList',
    FETCH_CLIENT_SUMMARY: 'fetchClientSummary',
    FETCH_CLIENT_PROJECT_LIST: 'fetchClientProjectList',
    FETCH_CLIENT_USER_LIST: 'fetchClientUserList',
    FETCH_CLIENT_WORKER_LIST: 'fetchClientWorkerList',
    FETCH_CLIENT_SUBCONTRACTOR_LIST: 'fetchClientSubcontractorList',
    FETCH_PROJECT: 'fetchProject',
    FETCH_PROJECT_LIST: 'fetchProjectList',
    FETCH_PROJECT_SUMMARY: 'fetchProjectSummary',
    FETCH_PROJECT_CLIENT_LIST: 'fetchProjectClientList',
    FETCH_CLIENT_LIST_FOR_MULTIPLE_PROJECTS: 'fetchClientListForMultipleProjects',
    FETCH_PROJECT_CLIENT_HIREARCHY_LIST: 'fetchProjectClientHirearchyList',
    FETCH_PROJECT_CATEGORY_LIST: 'fetchProjectCategoryList',
    FETCH_PROJECT_REGION_LIST: 'fetchProjectRegionList',
    FETCH_PROJECT_NAE_LIST: 'fetchProjectNaeList',
    FETCH_PROJECT_USER_LIST: 'fetchProjectUserList',
    FETCH_PROJECT_WORKER_LIST: 'fetchProjectWorkerList',
    FETCH_PROJECT_BADGE_VISITOR_LIST: 'fetchProjectBadgeVisitorList',
    FETCH_PROJECT_BADGE_ADDRESS_LIST: 'fetchProjectBadgeAddressList',
    FETCH_PROJECT_BADGE_VISITOR: 'fetchProjectBadgeVisitor',
    FETCH_USER_PROJECT_LIST: 'fetchUserProjectList',
    FETCH_USER_ROLE_LIST: 'fetchUserRoleList',
    FETCH_GROUP_SEARCH_LIST: 'fetchGroupSearchList',
    FETCH_SEARCH_CLIENT: 'fetchSearchClient',
    FETCH_SEARCH_CLIENT_2: 'fetchSearchClient2',
    FETCH_SEARCH_INVITE_CLIENT: 'fetchSearchInviteClient',
    FETCH_SEARCH_PROJECT: 'fetchSearchProject',
    FETCH_CERTIFICATION_LIST: 'fetchCertificationList',
    FETCH_PROJECT_ACCESS_CONTROL_SYSTEM_LIST: 'fetchProjectAccessControlSystemList',
    FETCH_PROJECT_BADGE_PRINTING_SYSTEM_LIST: 'fetchProjectBadgePrintingSystemList',
    FETCH_TRAINING_LIST: 'fetchTrainingList',
    FETCH_COURSE_LIST: 'fetchCourseList',
    FETCH_LEARNING_GROUPS: 'fetchLearningGroups',
    UPDATE_LEARNING_GROUPS_BULK: 'updateLearningGroupsBulk',
    FETCH_WORKER_COURSE_LIST: 'fetchWorkerCourseList',
    FETCH_LEARNER_WORKER: 'fetchLearnerWorker',
    UPDATE_LEARNER_WORKER_EXEMPTIONS: 'updateLearnerWorkerExemptions',
    CREATE_PAYMENT: 'createPayment',
    PROCESS_FAILED_PAYMENT: 'processFailedPayment',
    PROCESS_FAILED_PAYMENT_ON_ASSIGN_PROJECT: 'processFailedPaymentOnAssignProject',
    FETCH_PAYMENT_METHODS: 'fetchPaymentMethods',
    GET_OUTSTATDING_AMOUNT: 'getOutstandingAmount',
    DELETE_PAYMENT_METHOD: 'deletePaymentMethod',
    REPLACE_AND_DELETE_PAYMENT_METHOD: 'replaceAndDeletePaymentMethod',
    DELETE_CLIENT: 'deleteClient',
    DELETE_PROJECT: 'deleteProject',
    SEND_APPROVE_PROJECT: 'sendApproveProject',
    APPROVE_PROJECT: 'approveProject',
    ACCEPT_PROJECT: 'acceptProjectInvitation',
    UPDATE_CLIENT: 'updateClient',
    UPDATE_ONBAORDING_CLIENT: 'updateOnbaordingClient',
    ARCHIVE_CLIENT: 'archiveClient',
    UNARCHIVE_CLIENT: 'unarchiveClient',
    ARCHIVE_PROJECT: 'archiveProject',
    UNARCHIVE_PROJECT: 'unarchiveProject',
    FETCH_BILLING_TIER_LIST: 'fetchBillingTierList',
    ASSIGN_CLIENT_PROJECT: 'assignClientProject',
    ASSIGN_USER_PROJECT: 'assignUserProject',
    ASSIGN_ACCESS_CONTROL_SYSTEM_PROJECT: 'assignAccessControlSystemProject',
    ASSIGN_BADGE_PRINTING_SYSTEM_PROJECT: 'assignBadgePrintSystemProject',
    ASSIGN_WORKER_PROJECT: 'assignWorkerProject',
    UNASSIGN_WORKER_PROJECT: 'unassignWorkerProject',
    UNASSIGN_ACCESS_CONTROL_SYSTEM_PROJECT: 'unassignAccessControlSystemProject',
    UNASSIGN_BADGE_PRINTING_SYSTEM_PROJECT: 'unassignBadgePrintingSystemProject',
    UPDATE_ACCESS_CONTROL_SYSTEM_PROJECT: 'updateAccessControlSystemProject',
    UPDATE_PROJECT_ACCESS_CONTROL_SYSTEM_PROJECT: 'updateProjectAccessControlSystemProject',
    FETCH_PROJECT_ACCESS_CONTROL_SYSTEM: 'fetchProjectAccessControlSystem',
    FETCH_ACCESS_CONTROL_SYSTEM_LIST: 'fetchAccessControlSystemList',
    FETCH_ACCESS_CONTROL_SYSTEM_SUMMARY: 'fetchAccessControlSystemSummary',
    FETCH_ACCESS_CONTROL_SYSTEM: 'fetchAccessControlSystem',
    DELETE_ACCESS_CONTROL_SYSTEM: 'deleteAccessControlSystem',
    FETCH_FCA_TECH_PACKAGE_LIST: 'fetchFcaTechPackageList',
    SAVE_USER: 'saveUser',
    UPDATE_USER: 'updateUser',
    SAVE_ACCESS_CONTROL_SYSTEM: 'saveAccessControlSystem',
    SAVE_WORKER: 'saveWorker',
    UPLOAD_WORKER_PHOTO: 'uploadWorkerPhoto',
    FETCH_WORKER: 'fetchWorker',
    FETCH_ETHNICITY_LIST: 'fetchEthnicityList',
    FETCH_LANGUAGE_LIST: 'fetchLanguageList',
    FETCH_SKILLED_TRADE_LIST: 'fetchSkilledTradeList',
    FETCH_BADGE_PRINTER_SYSTEM: 'fetchBadgePrinterSystem',
    FETCH_BADGE_PRINTER_SYSTEM_LIST: 'fetchBadgePrinterSystemList',
    FETCH_BADGE_PRINTER_SYSTEM_SUMMARY: 'fetchBadgePrinterSystemSummary',
    SAVE_BADGE_PRINTER_SYSTEM: 'saveBadgePrinterSystem',
    UPDATE_BADGE_PRINTER_SYSTEM: 'updateBadgePrinterSystem',
    FETCH_WORKER_LIST: 'fetchWorkerList',
    FETCH_WORKER_STATISTICS: 'fetchWorkerStatistics',
    FETCH_PROJECT_WIDGET_STATISTICS: 'fetchProjectWidgetStatistics',
    FETCH_CLIENT_WIDGET_STATISTICS: 'fetchClientWidgetStatistics',
    FETCH_CLIENT_REVENUE_WIDGET_STATISTICS: 'fetchClientRevenueWidgetStatistics',
    FETCH_GROSS_REVENUE_WIDGET_STATISTICS: 'fetchGrossRevenueWidgetStatistics',
    FETCH_PROJECT_WORKERS_ACTIVITY_WIDGET_STATISTICS: 'fetchProjectWorkersActivityWidgetStatisctics',
    FETCH_NEW_ASSIGNED_WORKERS_WIDGET_STATISTICS: 'fetchNewAssignedWorkersWidgetStatisctics',
    FETCH_WORKERS_ACTIVITY_WIDGET_STATISTICS: 'fetchWorkersActivityWidgetStatisctics',
    FETCH_CLIENT_WORKERS_ACTIVITY_WIDGET_STATISTICS: 'fetchClientWorkersActivityWidgetStatisctics',
    FETCH_PROJECTS_ACS_STATISTICS: 'fetchProjectAccessControlSystemStatistics',
    FETCH_PROJECTS_BPS_STATISTICS: 'fetchProjectBadgePrintingSystemStatistics',
    FETCH_PROJECTS_CLIENTS_STATISTICS: 'fetchProjectClientsStatistics',
    FETCH_ACTIVE_LOCATIONS_STATISTICS: 'fetchActiveLocationsStatistics',
    FETCH_PROJECTS_BAGE_LOCATION_STATISTICS: 'fetchProjectBadgeLocationStatistics',
    FETCH_PROJECTS_BAGE_PROJECT_STATISTICS: 'fetchProjectBadgeProjectStatistics',
    FETCH_PROJECTS_REVENUE_PROJECT_STATISTICS: 'fetchProjectRevenueStatistics',
    FETCH_PROJECTS_TOP_TEN_STATISTICS: 'fetchProjectTopTenStatistics',
    FETCH_CLIENTS_TOP_TEN_STATISTICS: 'fetchClientTopTenStatistics',
    FETCH_IDENTIFICATION_TYPE: 'fetchIdentificationType',
    FETCH_SOC_JOB_TITLE: 'fetchSocJobTitle',
    FETCH_WORKER_CERTIFICATION: 'fetchWorkerCertification',
    FETCH_WORKER_PROJECT: 'fetchWorkerProject',
    FETCH_WORKER_PROJECT_FOR_TRANSFER: 'fetchWorkerProjectForTransfer',
    FETCH_WORKER_CERTIFICATION_SUMMARY: 'fetchWorkerCertificationSummary',
    FETCH_WORKER_PROJECT_LIST: 'fetchWorkerProjectList',
    FETCH_WORKERS_BY_PROJECT: 'fetchWorkersByProject',
    FETCH_WORKERS_BY_CLIENT: 'fetchWorkersByClient',
    FETCH_WORKERS_BY_LOCATION: 'fetchWorkersByLocation',
    FETCH_WORKERS_BY_JOB_DATA: 'fetchWorkersByJobData',
    FETCH_WORKERS_BY_TRADES_MINORITY: 'fetchWorkersByTradesMinority',
    FETCH_WORKERS_BY_TRADES_NON_MINORITY: 'fetchWorkersByTradesNonMinority',
    FETCH_WORKERS_BY_DEMOGRAPHIC_DATA: 'fetchWorkersByDemographicData',
    FETCH_WORKERS_TRAININGS: 'fetchWorkersTrainings',
    FETCH_WORKERS_NEW_WORKERS: 'fetchWorkersNewWorkers',
    FETCH_WORKERS_CERTIFICATIONS: 'fetchWorkersByCertifications',
    FETCH_WORKERS_OBSERVATIONS: 'fetchWorkersByObservations',
    FETCH_WORKER_OBSERVATION: 'fetchWorkerObservation',
    SAVE_WORKER_CERTIFICATION: 'saveWorkerCertification',
    UPDATE_WORKER_CERTIFICATION: 'updateWorkerCertification',
    DELETE_WORKER_CERTIFICATION: 'deleteWorkerCertification',
    FETCH_PROJECT_STATISTICS: 'fetchProjectStatistics',
    FETCH_CLIENT_STATISTICS: 'fetchClientStatistics',
    FETCH_INVENTORY_STATISTICS: 'fetchInventoryStatistics',
    FETCH_CONSENT_FORM: 'fetchConsentForm',
    SAVE_CONSENT_FORM: 'saveConsentForm',
    ASSIGN_WORKER_TO_COMPANY: 'assignWorkerToCompany',
    DISCONTINUE_WORKER_COMPANY: 'discontinueWorkerCompany',
    UPLOAD_WORKER_CERTIFICATION_LIST: 'uploadWorkerCertificationList',
    FETCH_BADGE: 'fetchBadge',
    UPDATE_BADGE: 'updateBadge',
    UPLOAD_FILE_LIST: 'uploadFileList',
    UPLOAD_FILE: 'uploadFile',
    SAVE_PROJECT_BADGES: 'saveProjectBadges',
    UPLOAD_PROJECT_BADGES: 'uploadGeneralContractorBadge',
    SAVE_PROJECT_BADGE_VISITOR: 'saveProjectBadgeVisitor',
    UPDATE_PROJECT_BADGE_VISITOR: 'updateProjectBadgeVisitor',
    UPDATE_BADGE_DATA: 'updateBadgeData',
    FETCH_BADGE_VISITOR_ENTITY_LIST: 'fetchBadgeVisitorEntityList',
    FETCH_NEW_BADGES: 'fetchNewBadges',
    FETCH_WORKERS_ACTIVITY_STATISTICS: 'fetchWorkersActivityStatistics',
    FETCH_GROSS_REVENUE: 'fetchGrossRevenue',
    UPDATE_PROJECT_BADGE: 'updateProjectBadge',
    PRINT_WORKER_BADGE: 'printWorkerBadge',
    FETCH_WORKER_BADGE_PDF: 'fetchWorkerBadgePDF',
    FETCH_VISITOR_BADGE_PDF: 'fetchVisitorBadgePDF',
    FETCH_WORKER_BADGE_REQUIREMENTS: 'fetchWorkerBadgeRequirements',
    DOWNLOAD_FILE: 'downloadFile',
    RESET_PASSWORD: 'resetPassword',
    CHANGE_PASSWORD: 'changePassword',
    CONFIRM_RESET_PASSWORD: 'confirmResetPassword',
    VALIDATE_RESET_PASSWORD_TOKEN: 'validateResetPasswordToken',
    FETCH_WORKER_TRAINING: 'fetchWorkerTraining',
    SAVE_WORKER_TRAINING: 'saveWorkerTraining',
    UPDATE_WORKER_TRAINING: 'updateWorkerTraining',
    DELETE_WORKER_TRAINING: 'deleteWorkerTraining',
    FETCH_WORKER_TRAINING_SUMMARY: 'fetchWorkerTrainingSummary',
    UPLOAD_WORKER_TRAINING_LIST: 'uploadWorkerTrainingList',
    FETCH_INVOICE_LIST: 'fetchProjectInvoiceList',
    FETCH_PROJECT_INVOICE: 'fetchProjectInvoice',
    DOWNLOAD_INVOICE: 'downloadInvoice',
    UPDATE_UPCOMING_INVOICE: 'updateUpcomingInvoice',
    UPDATE_BILLING_ENGINE_UPCOMING_INVOICE: 'updateBillingEngineUpcomingInvoice',
    SAVE_INVOICE: 'saveInvoice',
    FETCH_SERVICE_TYPE_LIST: 'fetchServiceTypeList',
    PRINT_VISITOR_BADGE: 'printVisitorBadge',
    FETCH_INVOICE_STATISTICS: 'fetchInvoiceStatistics',
    FETCH_INVOICE_SUMMARY: 'fetchInvoiceSummary',
    FETCH_WORKER_ACTIVITY_LIST: 'fetchWorkerActivityList',
    FETCH_WORKER_OBSERVATION_LIST: 'fetchWorkerObservationList',
    DELETE_INVOICE: 'deleteInvoice',
    MARK_AS_PAID_INVOICE: 'markAsPaidInvoice',
    MARK_AS_VOID_INVOICE: 'markAsVoidInvoice',
    FETCH_INVOICE: 'fetchInvoice',
    EDIT_INVOICE: 'editInvoice',
    PAY_INVOICE: 'payInvoice',
    CONFIRM_INVOICE: 'confirmInvoice',
    FETCH_BADGE_HISTORY: 'fetchBadgeHistory',
    UPDATE_PROFILE: 'updateProfile',
    FETCH_ACCOUNT: 'fetchAccount',
    FETCH_USER_PROFILE: 'fetchUserProfile',
    UPLOAD_PROFILE_PHOTO: 'uploadProfilePhoto',
    UPDATE_PROFILE_PHOTO: 'updateProfilePhoto',
    FETCH_CLIENT_DETAIL_STATISTICS: 'fetchClientDetailStatistics',
    FETCH_PROJECT_DETAIL_STATISTICS: 'fetchProjectDetailStatistics',
    FETCH_CLIENTS_BY_TRADES: 'fetchClientsByTrades',
    DOWNLOAD_CONSENT_FORM: 'downloadConsentForm',
    FETCH_COUNTRY_LIST: 'fetchCountryList',
    FETCH_PROJECT_CLIENT_SUMMARY: 'fetchProjectClientSummary',
    UPDATE_PROJECT_CLIENT_TAX_CONDITION: 'updateProjectClientTaxCondition',
    FETCH_TIME_ZONE_LIST: 'fetchTimeZoneList',
    UPDATE_PROJECT_PAYMENT_METHOD: 'updateProjectPaymentMethod',
    FETCH_PROCORE: 'fetchProcore',
    SAVE_PROCORE: 'saveProcore',
    DISCONNECT_PROCORE: 'disconnectProcore',
    FETCH_PROCORE_PROJECTS: 'fetchProcoreProjects',
    FETCH_PROCORE_PROJECT_MAPPINGS: 'fetchProcoreProjectMapping',
    FETCH_PROCORE_VENDORS: 'fetchProcoreVendors',
    FETCH_PROCORE_VENDOR_MAPPINGS: 'fetchProcoreVendorMappings',
    SAVE_PROCORE_PROJECT_MAPPINGS: 'saveProcoreProjectMapping',
    SAVE_PROCORE_VENDOR_MAPPINGS: 'saveProcoreVendorMapping',
    FETCH_PROCORE_CLIENTS: 'fetchProcoreClients',
    FETCH_PROCORE_REPORT_FREQUENCY: 'fetchProcoreReportFrequency',
    SAVE_PROCORE_REPORT_FREQUENCY: 'saveProcoreReportFrequency',
    FETCH_GEOGRAPHIC_LOCATIONS: 'fetchGeographicLocations',
    FETCH_JOB_TITLES: 'fetchJobTitles',
    FETCH_SOC_JOB_TITLES: 'fetchSocJobTitles',
    FETCH_TRADE_STATUSES: 'fetchTradeStatuses',
    FETCH_LANGUAGE_TURNER_PROTOCOLS: 'fetchLanguageTurnerProtocols',
    FETCH_SEARCH: 'fetchSearch',
    FETCH_SEARCH_MORE: 'fetchSearchMore',
    FETCH_ADMIN_PERMISSION: 'fetchAdminPermission',
    FETCH_USER_PERMISSIONS: 'fetchUserPermissions',
    FETCH_PROJECT_CERTIFICATIONGROUP: 'fetchProjectCertificationGroup',
    FETCH_PROJECT_TRAININGGROUP: 'fetchProjectTrainingGroup',
    FETCH_LABOR_CENSUS: 'fetchLaborCensus',
    ADD_CUSTOM_BADGE_FIELDS: 'addCustomBadgeFields',
    FETCH_CUSTOM_BADGE_FIELDS: 'fetchCustomBadgeFields',
    FETCH_FEATURE_FLAG: 'fetchFeatureFlagList',
    RETIRE_BADGE_TEMPLATE: 'retireBadgeTemplate',
    UPDATE_BADGE_TEMPLATE_STATUS: 'updateBadgeTemplateStatus',
    FETCH_BADGE_TEMPLATE_EXCEPTIONS: 'fetchBadgeTemplateExceptions',
    UPDATE_PROJECT_BADGE_TEMPLATE: 'updateProjectBadgeTemplate',
    PREVIEW_UPLOADED_BADGE_TEMPLATE: 'previewUploadedBadgeTemplate',
    FETCH_BADGE_DEACTIVATION_REASONS: 'fetchBadgeDeactivationReasons',
    UPDATE_WELCOME_KIT: 'updateWelcomeKit',
    FETCH_DASHBOARD_FILTER: 'fetchDashboardFilter',
    SAVE_DASHBOARD_FILTER: 'saveDashboardFilter',
    DELETE_DASHBOARD_FILTER: 'deleteDashboardFilter',
    UPDATE_DASHBOARD_FILTER: 'updateDashboardFilter',
    FETCH_BADGE_TYPES: 'fetchBadgeTypes',
    DELETE_WORKER: 'deleteWorker',
    TRANSFER_WORKER: 'transferWorker',
    RESET_LOCATIONS: 'resetLocations',
    FETCH_LOCATIONS_BY_BADGE_ID: 'fetchLocationByBadgeId',
    FETCH_PROJECT_TURNSTILE_SCHEDULE_TIME_SLOTS: 'fetchProjectTurnstileScheduleTimeSlots',
    ADD_PROJECT_TURNSTILE_SCHEDULE_TIME_SLOT: 'addProjectTurnstileScheduleTimeSlot',
    UPDATE_PROJECT_TURNSTILE_SCHEDULE_TIME_SLOT: 'updateProjectTurnstileScheduleTimeSlot',
    DELETE_PROJECT_TURNSTILE_SCHEDULE_TIME_SLOT: 'deleteProjectTurnstileScheduleTimeSlot',
    FETCH_PROJECT_TURNSTILE_SCHEDULES: 'fetchProjectTurnstileSchedules',
    ADD_PROJECT_TURNSTILE_SCHEDULES: 'addProjectTurnstileSchedules',
    TURN_ON_PROJECT_TURNSTILE_SCHEDULES: 'turnOnProjectTurnstileSchedules',
    TURN_OFF_PROJECT_TURNSTILE_SCHEDULES: 'turnOffProjectTurnstileSchedules',
    SEND_COMMUNICATION: 'sendCommunication',
    SEND_COMMUNICATION_CONFIRMATION: 'SEND_COMMUNICATION_CONFIRMATION',
    FETCH_PROJECT_COMMUNICATIONS: 'fetchProjectCommunications',
    UPDATE_NEW_REPLIES_COUNT: 'updateNewRepliesCount',
    CHANGE_FCA_USER_STATUS: 'changeFcaUserStatus',
    FETCH_WORKER_CONTROL_SETTINGS: 'fetchWorkerControlSettings',
    FETCH_WORKER_PROFILE_CUSTOM_FIELDS: 'getWorkerProfileCustomFields',
    FETCH_WORKER_PROFILE_DEFAULT_CUSTOM_FIELDS: 'getWorkerProfileDefaultCustomFields',
    FETCH_PROJECT_COMPANY_GROUPS: 'fetchProjectCompanyGroups',
    FETCH_PROJECT_TYPES: 'fetchProjectTypes',
    DELETE_USER: 'deleteUser',
    FETCH_PRODUCT: 'fetchProduct',
    FETCH_PRODUCT_LIST: 'fetchProductList',
    SAVE_PRODUCT: 'saveProduct',
    DELETE_PRODUCT: 'deleteProduct',
    RETIRE_PRODUCT: 'retireProduct',
    FETCH_PRODUCT_CATEGORIES: 'fetchProductCategories',
    FETCH_QUICKBOOKS_ACCOUNTS: 'fetchQuickBooksAccounts',
    FETCH_PROJECT_COMPANY: 'fetchProjectCompany',
    UPDATE_PROJECT_COMPANY: 'updateProjectCompany',
    FETCH_JOINT_VENTURE_COMPANY_USERS: 'fetchJointVentureCompanyUsers',
    FETCH_PROJECT_BILLING_ENGINE_RULES: 'fetchProjectBillingEngineRules',
    FETCH_PROJECT_PRICING_AGREEMENT_EXPORT: 'fetchProjectPricingAgreementExport',
    FETCH_PROJECT_BILLING_ENGINE_RULES_CHECK: 'fetchProjectBillingEngineRulesCheck',
    FETCH_PROJECT_BILLING_ENGINE_RULES_PRICING: 'fetchProjectBillingEngineRulesPricing',
    FETCH_PROJECT_BILLING_MODEL_PRICING: 'fetchProjectBillingModelPricing',
    ADD_BILLING_ENGINE_RULES: 'addBillingEngineRules',
    ADD_BILLING_ENGINE_PRODUCT_BUNDLES: 'addBillingEngineProductBundles',
    FETCH_PRODUCT_BILLING_TRIGGERS: 'fetchProductBillingTriggers',
    UPDATE_PRICING_AGREEMENT_VISIBILITY: 'updatePricingAgreementVisibility',
    ADD_ACS_DATES: 'addACSDates',
    ADD_BPS_DATES: 'addBPSDates',
    UPDATE_BILLING_ENGINE_SETTINGS: 'updateBillingEngineSettings',
    FETCH_BILLING_ENGINE_SETTINGS: 'fetchBillingEngineSettings',
    FETCH_USER_CONTACT: 'fetchUserContact',
    VALIDATE_PASSWORD: 'validatePassword',
    CREATE_USER_CONTACT: 'createUserContact',
    VERIFY_USER_CONTACT: 'verifyUSerContact',
    MAKE_PRIMARY_USER_CONTACT: 'makePrimaryUserContact',
    REMOVE_USER_CONTACT: 'removeUserContact',
    VALIDATE_USER: 'validateUser',
    APPROVE_USER: 'approveUser',
    DENY_USER: 'denyUser',
    FETCH_DASHBOARD_REGION_LIST: 'fetchDashboardRegionList',
    FETCH_DASHBOARD_PROJECTS: 'fetchDashboardProjects',
    FETCH_WORK_FORCE_MONITORING_DATA: 'fetchWorkForceMonitoringData',
    FETCH_DAILY_LOG_DATA: 'fetchDailyLogData',
    FETCH_WFM_EXPANDED_WORKERS_ONSITE: 'fetchWfmExpandedWorkersOnsite',
    FETCH_WFM_EXPANDED_COMPANIES_ONSITE: 'fetchWfmExpandedCompaniesOnsite',
    FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE: 'fetchWfmExpandedWorkersForCompanyOnsite',
    FETCH_WFM_EXPANDED_TRADES_ONSITE: 'fetchWfmExpandedTradesOnsite',
    FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE: 'fetchWfmExpandedWorkersForTradeOnsite',
    FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES: 'fetchDailyLogExpandedTradesOnsite',
    FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE: 'fetchDailyLogExpandedWorkersForTradeOnsite',
    FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED: 'fetchDailyLogExpandedNewWorkersBadged',
    FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED: 'fetchDailyLogExpandedNewCompaniesEnrolled',
    FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY: 'fetchDailyLogExpandedWorkersForNewCompany',
    FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT: 'fetchDailyLogExpandedTotalHeadcount',
    FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES: 'fetchDailyLogExpandedTotalCompanies',
    FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY: 'fetchDailyLogExpandedWorkersForTotalCompany',
    FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS: 'fetchDailyLogExpandedTotalOnsiteHours',
    FETCH_FAILED_TRANSACTIONS: 'fetchFailedTransactions',
    FETCH_CHANGE_LOGS_SEARCH: 'fetchChangeLogsSearch',
    FETCH_DASHBOARD_WIDGET_DOWNLOADS: 'fetchDashboardWidgetDownloads',
    FETCH_IN_PROGRESS_WIDGET_EXPORTS: 'fetchInProgressWidgetExports',
    FETCH_PRICING_AGREEMENT_DOWNLOADS: 'fetchPricingAgreementDownloads',
    EXPORT_WIDGET_DATA_WFM_WORKERS_ONSITE: 'exportWidgetDataWfmWorkersOnsite',
    EXPORT_WIDGET_DATA_WFM_COMPANIES_ONSITE: 'exportWidgetWfmCompaniesOnsite',
    EXPORT_WIDGET_DATA_WFM_TRADES_ONSITE: 'exportWidgetDataWfmTradesOnsite',
    EXPORT_WIDGET_DATA_DAILY_LOG_NEW_WORKERS_BADGED: 'exportWidgetDataDailyLogNewWorkersBadged',
    EXPORT_WIDGET_DATA_DAILY_LOG_NEW_COMPANIES_ENROLLED: 'exportWidgetDataDailyLogNewCompaniesEnrolled',
    EXPORT_WIDGET_DATA_DAILY_LOG_TOTAL_TRADES: 'exportWidgetDataDailyLogTotalTrades',
    EXPORT_WIDGET_DATA_DAILY_LOG_TOTAL_HEADCOUNT: 'exportWidgetDataDailyLogTotalHeadcount',
    EXPORT_WIDGET_DATA_DAILY_LOG_TOTAL_COMPANIES: 'exportWidgetDataDailyLogTotalCompanies',
    EXPORT_WIDGET_DATA_DAILY_LOG_TOTAL_HOURS: 'exportWidgetDataDailyLogTotalHours',
    ASSIGN_PROJECTS_TO_CREDIT_CARD_START: 'assignProjectsToCreditCard',
    VERIFY_CVC: 'verifyCvc',
    FETCH_MERGE_COMPANY_BILLING_SUMMARY: 'fetchMergeCompanyBillingSummary',
    FETCH_ALL_ACTIVE_CLIENTS: 'fetchAllActiveClients',
    FETCH_MERGE_COMPANY_INVOICES: 'fetchMergeCompanyInvoices',
    FETCH_MERGE_COMPANY_INVOICES_SUMMARY: 'fetchMergeCompanyInvoicesSummary',
    FETCH_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY: 'fetchMergeCompanyReviewInvoicesSummary',
    FETCH_MERGE_COMPANY_WORKERS: 'fetchMergeCompanyWorkers',
    UPLOAD_WORKER_GOVERNMENT_DOCUMENTS: 'uploadWorkerGovernmentDocuments',
    DELETE_WORKER_GOVERNMENT_DOCUMENTS: 'deleteWorkerGovernmentDocuments',
    FETCH_TARGET_COMPANIES_FOR_WORKER_TRANSFER: 'fetchTargetCompaniesForWorkerTransfer',
    UPDATE_UNVERIFIED_COMPANY_SPONSOR: 'updateUnverifiedCompanySponsor',
    FETCH_HARDWARE_TYPE_LIST: 'fetchHardwareTypeList',
    FETCH_FCA_ADMINS: 'fetchFCAAdminsList',
    FETCH_PROJECTS_ACCESS_CONTROL_SYSTEM_VERIFY_CONFIGURATION: 'fetchProjectAccessControlSystemVerifyConfiguration',
    FETCH_MANAGED_BY_OPTIONS_LIST: 'fetchManagedByOptionsList',
    UPDATE_PENDING_WELCOME_CLIENT_NOTES: 'updatePendingWelcomeClientNotes',
  },
  TRACE_KEY: {
    SAVE_UPLOAD_WORKER_CERTIFICATION: 'saveUploadWorkerCertification',
    UPDATE_UPLOAD_WORKER_CERTIFICATION: 'updateUploadWorkerCertification',
    SAVE_UPLOAD_PROJECT_BADGE: 'saveUploadProjectBadge',
    SAVE_UPLOAD_WORKER_TRAINING: 'saveUploadWorkerTraining',
    UPDATE_UPLOAD_WORKER_TRAINING: 'updateUploadWorkerTraining',
    SAVE_UPLOAD_PROFILE_PHOTO: 'saveUploadProfilePhoto',
    SAVE_COMMUNICATION: 'saveCommunication',
  },
};
